import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';
import { parseISO, format, isBefore, isAfter, isEqual, addDays } from 'date-fns';

export const assignmentDateOverlapValidator = (assignmentDateList: Set<string>): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    let from: string | null = null;
    let to: string | null = null;

    if (control instanceof FormGroup) {
      from = control.get('from')?.value;
      to = control.get('to')?.value;
    } else if (control.value && control.value.from && control.value.to) {
      from = control.value.from;
      to = control.value.to;
    }

    if (!from || !to) return null;

    const fromDate = parseISO(from);
    const toDate = parseISO(to);

    if (isAfter(fromDate, toDate)) {
      return { invalidRange: true };
    }

    let current = fromDate;
    while (isBefore(current, toDate) || isEqual(current, toDate)) {
      const formatted = format(current, 'yyyy-MM-dd');
      if (assignmentDateList.has(formatted)) {
        return { assignmentOverlap: true };
      }
      current = addDays(current, 1);
    }

    return null;
  };
};
